export default "__VITE_ASSET__DyTEuS3F__"